import moment from 'moment'
import { ReservationRequest } from '../api/data/ReservationRequest'
import { dateFormat } from '../helper/DateModel'

export interface DatesTabVM {
  checkoutDate: string
  checkoutTime: string
  returnDate: string
  returnTime: string
  testDriveLength:string  
}

export function datesTabVMMapper(reservation: ReservationRequest | undefined): DatesTabVM {
  const dateRangeVM: DatesTabVM = {
    checkoutDate: reservation?.pickupDateTime ? dateFormat(reservation?.pickupDateTime ?? new Date(), 'date_only') : '',
    checkoutTime: reservation?.pickupDateTime ? dateFormat(reservation?.pickupDateTime ?? new Date(), 'time_only_with_am_pm') : '08:00 AM',
    returnDate: reservation?.dropOffDateTime ? dateFormat(reservation?.dropOffDateTime ?? new Date(), 'date_only') : '',
    returnTime: reservation?.dropOffDateTime ? dateFormat(reservation?.dropOffDateTime ?? new Date(), 'time_only_with_am_pm') : '08:00 AM',
    testDriveLength: dateFormat(new Date(), 'date_only')
  }
  return dateRangeVM
}
